const roundNumber = (num, decimals) => {
    // If num is null, return the same value
    if (num === null) {
        return num;
    }
    // Rounds number 'num' to 'decimals' decimal places, at most.
    return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export { roundNumber };